module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "is-ancestor tile"
  }, [_c('div', {
    staticClass: "tile is-parent column is-half is-offset-one-quarter"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Login ")]), _vm._v(" "), _c('div', {
    staticClass: "block styles-box"
  }, [(_vm.error) ? _c('notification', {
    attrs: {
      "title": 'Oh Snap',
      "container": '.styles-box',
      "type": 'danger',
      "direction": 'Down',
      "message": _vm.error,
      "duration": 0
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.Formerrors.username
    },
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.username = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.Formerrors.username) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.Formerrors.username))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.Formerrors.password
    },
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.Formerrors.password) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.Formerrors.password))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n                Login\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        _vm.navigate()
      }
    }
  }, [_vm._v("\n                Register\n              ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6e8ccd"}!./client/views/auth/login/template.html
// module id = 230
// module chunks = 17